const initialState = {
   getBlogInProgress: false,
   getBlogPostInProgress: false,
   getBlogCategoriesInProgress: false,
   getBlogSettingsInProgress: false,
   categories: [],
   blog: [],
   post: {},
   updatedPost: {},
   showFullScreenLoader: false,
};

export default initialState;
